var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-nav'),_c('div',{staticClass:"main-graph",attrs:{"id":"main-content","role":"application","aria-label":"graph"}},[_c('cv-loading',{attrs:{"id":"app-busy-icon","active":_vm.isLoading,"overlay":""}}),_c('graph-summary-top-panel'),_c('keep-alive',[_c('graph')],1),_c('side-panel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }